/**
 * Output style for AI widget results (length and tone of each of the 5 points).
 */
export const DEFAULT_OUTPUT_MODE = 'elaborate';

export const OUTPUT_MODE_OPTIONS = [
  {
    value: 'precise',
    label: 'Precise',
    description:
      'One short qualitative sentence per point (~10–15 words), without statistics or numbers. Best for quick scanning.',
  },
  {
    value: 'elaborate',
    label: 'Elaborate',
    description:
      'Richer explanations (~25–40 words) with context, numbers, and implications. Default style.',
  },
  {
    value: 'formal',
    label: 'Formal',
    description:
      'Executive-ready professional tone (~18–24 words per point). Suitable for reports and leadership summaries.',
  },
];
